import { useEffect } from "react";
import { useRouter } from "@/router/Router";
import { useI18n } from "@/i18n";
import { useCatalog } from "@/state/CatalogContext";
import { useCategories } from "@/lib/categories";

const BRAND = "KMS ROASTING";

/** Browser tab title for every screen (a blog post sets its own once loaded). */
export function RouteMeta() {
  const { route } = useRouter();
  const { t } = useI18n();
  const { products } = useCatalog();
  const categories = useCategories();
  useEffect(() => {
    let title = "";
    switch (route.name) {
      case "home":
        title = `${t("desktop.heroTitle1")} ${t("desktop.heroTitle2")}`;
        break;
      case "catalog": {
        const cat = categories?.find((c) => c.slug === route.category);
        title = route.q ? `${route.q} — ${t("desktop.catalog")}` : cat ? cat.name : route.category === "group-equipment" ? t("desktop.equipment") : route.category === "group-accessories" ? t("desktop.accessories") : t("desktop.catalog");
        break;
      }
      case "product":
        title = products.find((p) => p.slug === route.slug)?.name ?? "";
        break;
      case "cart":
        title = t("cart.title");
        break;
      case "checkout":
        title = t("desktop.checkoutTitle");
        break;
      case "posts":
        title = t("desktop.blog");
        break;
      case "post":
        title = route.slug === "about" ? t("desktop.about") : "";
        break;
      case "lead":
      case "b2b":
        title = t("lead.title");
        break;
      case "profile":
        title = t("desktop.accTitle");
        break;
      case "orders":
      case "orderDetail":
        title = t("orders.title");
        break;
      case "orderConfirmation":
        title = t("orderConfirmation.title");
        break;
      case "favorites":
        title = t("profile.favorites");
        break;
      case "flavors":
        title = t("desktop.fwTitle");
        break;
      case "faq":
        title = t("faq.title");
        break;
      default:
        title = "";
    }
    if (route.name === "post" && route.slug !== "about") return; // DesktopPost / PostPage set it
    document.title = route.name === "home" ? `${BRAND} — ${title}` : title ? `${title} — ${BRAND}` : BRAND;
  }, [route, t, products, categories]);
  return null;
}
